import { apiRequest } from '@/api/client';
import type { RoadmapItem } from '@/types';

export interface RoadmapQuery {
  category: string;
  status?: string;
  limit?: number;
}

export async function fetchRoadmapItems(
  accessToken: string,
  query: RoadmapQuery,
  sessionId?: string | null,
): Promise<RoadmapItem[]> {
  const params = new URLSearchParams({ category: query.category });
  if (query.status) params.set('status', query.status);
  if (query.limit) params.set('limit', String(query.limit));

  const data = await apiRequest<{ items?: RoadmapItem[] }>(
    `/roadmap/items?${params}`,
    { accessToken, sessionId },
  );
  return data.items ?? (Array.isArray(data) ? data : []);
}

export async function fetchRoadmapItem(
  itemId: string,
  category: string,
  accessToken: string,
  sessionId?: string | null,
): Promise<RoadmapItem> {
  return apiRequest<RoadmapItem>(
    `/roadmap/items/${encodeURIComponent(itemId)}?category=${encodeURIComponent(category)}`,
    { accessToken, sessionId },
  );
}
